// The federation's competitions a paired club team plays in: what the read-only CMS lists for a
// club. Its users may read more of the federation (an admin of it reads all of it, and a club with
// several paired teams reads each team's competitions), but the page is about the selected team.
// Undefined until both lists have loaded.
const teamCompetitionsOf = (federationCompetitions, teamCompetitions, federationId) => {
  if (!federationCompetitions || !teamCompetitions) return undefined
  const theTeams = new Set(
    teamCompetitions.filter((c) => c.fedOrgId === federationId).map((c) => c.competitionId),
  )
  return federationCompetitions.filter((c) => theTeams.has(c.id))
}

export default teamCompetitionsOf
